import React, { useState } from "react";
import { FaExchangeAlt, FaCogs, FaLock, FaMinus, FaPlus, FaChartLine, FaBalanceScale, FaCalendarCheck, FaFileInvoiceDollar, FaFileMedical, FaVideo, FaNetworkWired, FaMobileAlt, FaChartPie } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Ehr = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">EHR System Integration Services</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs,we provide EHR system integration services to enhance the interoperability of healthcare platforms. Our team specializes in designing, developing, and managing secure and efficient data exchange solutions that streamline healthcare workflows.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>


                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Optimized Interoperability",
        description: "Ensure seamless data exchange between multiple healthcare systems.",
        icon: FaExchangeAlt
    },
    {
        title: "Custom API Solutions",
        description: "Develop tailored APIs that meet your unique healthcare integration needs.",
        icon: FaFileMedical
    },
    {
        title: "Secure & Compliant Systems",
        description: "Maintain full compliance with HIPAA, HL7, and FHIR regulations.",
        icon: FaLock
    },
    {
        title: "Faster Implementation",
        description: "Reduce deployment time with our streamlined integration processes.",
        icon: FaCalendarCheck
    },
    {
        title: "Data Accuracy & Consistency",
        description: "Eliminate errors with automated data synchronization across platforms.",
        icon: FaChartLine
    },
    {
        title: "Scalable Solutions",
        description: "Easily expand your healthcare system capabilities as your organization grows.",
        icon: FaBalanceScale
    },
    {
        title: "Cost-Effective Integration",
        description: "Reduce IT costs while improving efficiency and workflow automation.",
        icon: FaFileInvoiceDollar
    },
    {
        title: "24/7 Support & Monitoring",
        description: "Get round-the-clock assistance and real-time system monitoring.",
        icon: FaVideo
    }
];



const services = [

    {
        title: " Interoperability Solutions",
        description: " Enable seamless communication between various healthcare platforms.."
    },
    {
        title: " Real-Time Data Exchange",
        description: " Ensure quick and accurate access to patient records, lab results, and treatment history."
    },
    {
        title: "Remote Monitoring",
        description: "Integrate EHR with telehealth platforms for virtual consultations and real-time patient tracking."
    },
    {
        title: "Billing & Insurance Integration",
        description: "Automate claims processing, insurance verification, and medical billing."
    },
    {
        title: "Patient Engagement Tools",
        description: "Enhance patient interactions through integrated portals, appointment scheduling, and automated reminders."
    },
    {
        title: "FHIR-Based Data Standardization",
        description: " Implement FHIR-compliant data structures for improved data consistency across systems."
    }
];
const whyChooseUs = [
    {
        title: "Comprehensive Compatibility",
        description: "Seamlessly integrate with leading EHR and EMR systems for smooth data exchange across platforms.",
        icon: FaExchangeAlt
    },
    {
        title: "HIPAA & HL7 Compliance",
        description: "Ensure secure and standardized data exchange with full compliance to HIPAA, HL7, and FHIR regulations.",
        icon: FaBalanceScale
    },
    {
        title: "Enhanced Security & Privacy",
        description: "Protect sensitive patient data with end-to-end encryption, role-based access, and secure authentication.",
        icon: FaLock
    },
    {
        title: "Scalability & Performance",
        description: "Handle large volumes of healthcare data efficiently without compromising system performance.",
        icon: FaChartLine
    },
    {
        title: "Automated Workflows",
        description: "Reduce administrative workload with automated patient data entry, prescription management, and record synchronization.",
        icon: FaCogs
    },
    {
        title: "Multi-System Integration",
        description: "Connect laboratory systems, pharmacy management, imaging platforms, and telehealth services into a unified ecosystem.",
        icon: FaNetworkWired
    },
    {
        title: "User-Friendly Dashboards",
        description: "Enable healthcare professionals with intuitive dashboards for real-time patient data access.",
        icon: FaChartPie
    },
    {
        title: "Cross-Platform Accessibility",
        description: "Ensure smooth functionality across web, mobile, and cloud-based applications for maximum usability.",
        icon: FaMobileAlt
    },
    {
        title: "Custom API Development",
        description: "We create tailored APIs to meet specific healthcare needs, enabling real-time data access and synchronization."
    },
    {
        title: "Real-Time Alerts & Notifications",
        description: "Improve patient engagement and care coordination with automated alerts for critical updates and appointments."
    },
    {
        title: "Seamless Patient Data Migration",
        description: "Effortlessly transfer patient records between systems without data loss, ensuring continuity of care."
    },
    {
        title: "AI & Predictive Analytics",
        description: "Leverage machine learning to provide predictive insights, helping healthcare providers make informed decisions."
    }
];;

const List = [
    
        {
            "title": "EHR System Integration",
            "description": "Seamlessly connect diverse healthcare platforms, enabling efficient and secure data exchange between hospitals, clinics, pharmacies, and laboratories. Our integration solutions ensure real-time access to patient records, improving care coordination and reducing administrative overhead."
        },
        {
            "title": "Custom API Development",
            "description": "Develop tailored APIs that facilitate real-time data synchronization and interoperability across multiple healthcare systems. Our APIs ensure secure, standardized, and scalable communication between different platforms, including EHRs, insurance providers, and telemedicine applications."
        },
        {
            "title": "Data Migration Services",
            "description": "Ensure secure, accurate, and efficient transfer of patient records from legacy systems to modern EHR platforms. Our migration services minimize downtime, prevent data loss, and maintain regulatory compliance while upgrading your healthcare infrastructure."
        },
        {
            "title": "Telemedicine Integration",
            "description": "Enhance virtual care by integrating telehealth platforms with EHR systems. Our solutions enable seamless video consultations, remote patient monitoring, e-prescriptions, and real-time access to medical histories, enhancing both provider efficiency and patient experience."
        },
        {
            "title": "Patient Engagement Solutions",
            "description": "Improve patient experience with interactive portals that allow secure access to medical records, appointment scheduling, automated reminders, and direct communication with healthcare providers. These solutions enhance patient satisfaction, adherence to treatment plans, and overall health outcomes."
        },
        {
            "title": "Healthcare Analytics & Reporting",
            "description": "Leverage AI-driven analytics to gain actionable insights into patient trends, treatment effectiveness, and operational efficiency. Our reporting tools provide real-time dashboards, predictive analytics, and compliance tracking to support data-driven decision-making."
        },
        {
            "title": "Medical Billing & Insurance Integration",
            "description": "Streamline claims processing, insurance verification, and billing workflows by integrating medical billing systems with EHRs. Our automated solutions reduce errors, improve reimbursement rates, and ensure compliance with healthcare payment regulations."
        },
        {
            "title": "Security & Compliance Solutions",
            "description": "Protect patient data with advanced security measures, including HIPAA, HL7, and FHIR compliance. We implement encryption, multi-factor authentication, and audit logging to safeguard sensitive healthcare information against breaches and unauthorized access."
        },
        {
            "title": "Real-Time Monitoring & Support",
            "description": "Ensure uninterrupted system performance with continuous monitoring, proactive bug fixes, and performance optimization. Our 24/7 support team provides rapid issue resolution, software updates, and security patches to maintain system reliability."
        }
    ]
    



export default Ehr;
